(function (root) {
  'use strict';

  var HEIGHTS = [107, 142, 179, 218];
  var CLOSE_MM = 30;
  var SHELF_DEPTH_MM = 30;

  var BURNERS = [
    { id: 'R1', family: 'R', shape: 'rectangular', width: 274, depth: 205 },
    { id: 'R2', family: 'R', shape: 'rectangular', width: 317, depth: 205 },
    { id: 'R3', family: 'R', shape: 'rectangular', width: 342, depth: 205 },
    { id: 'R4', family: 'R', shape: 'rectangular', width: 402, depth: 205 },
    { id: 'R5', family: 'R', shape: 'rectangular', width: 432, depth: 205 },
    { id: 'T1', family: 'T', shape: 'tapered', front: 366, rear: 260, depth: 135, bioEthanol: false },
    { id: 'T2', family: 'T', shape: 'tapered', front: 330, rear: 220, depth: 95 },
    { id: 'T3', family: 'T', shape: 'tapered', front: 366, rear: 240, depth: 182 },
    { id: 'T4', family: 'T', shape: 'tapered', front: 408, rear: 280, depth: 182 },
    { id: 'V1', family: 'V', shape: 'victorian', front: 220, maxWidth: 276, rear: 230, depth: 108, depthToWidest: 58 },
    { id: 'V2', family: 'V', shape: 'victorian', front: 288, maxWidth: 375, rear: 173, depth: 149, depthToWidest: 77 },
    { id: 'V3', family: 'V', shape: 'victorian', front: 240, maxWidth: 348, rear: 248, depth: 189, depthToWidest: 135 },
    { id: 'V4', family: 'V', shape: 'victorian', front: 232, maxWidth: 302, rear: 165, depth: 130, depthToWidest: 88 },
    { id: 'V5', family: 'V', shape: 'victorian', front: 267, maxWidth: 400, rear: 155, depth: 170, depthToWidest: 80 },
    { id: 'V6', family: 'V', shape: 'victorian', front: 240, maxWidth: 315, rear: 280, depth: 204, depthToWidest: 152 },
    { id: 'V7', family: 'V', shape: 'victorian', front: 280, maxWidth: 370, rear: 170, depth: 124, depthToWidest: 58 },
    { id: 'V8', family: 'V', shape: 'victorian', front: 247, maxWidth: 408, rear: 170, depth: 245, depthToWidest: 174 },
    { id: 'V9', family: 'V', shape: 'victorian', front: 240, maxWidth: 370, rear: 227, depth: 223, depthToWidest: 163 }
  ];

  function pickHeight(available) {
    var n = Number(available);
    if (!isFinite(n) || n <= 0) return null;
    var best = null;
    for (var i = 0; i < HEIGHTS.length; i++) {
      if (HEIGHTS[i] <= n && (best === null || HEIGHTS[i] > best)) best = HEIGHTS[i];
    }
    return best;
  }

  function openingWidthAt(opening, depthPos) {
    var A = opening.front;
    var B = opening.depth;
    var C = opening.rear;
    var D = opening.maxWidth;
    var E = opening.depthToWidest;
    if (D == null || E == null || B <= 0) return Math.max(A || 0, C || 0, D || 0);
    if (depthPos <= E) {
      if (E === 0) return D;
      return A + (D - A) * (depthPos / E);
    }
    var rest = B - E;
    if (rest <= 0) return D;
    return D + (C - D) * ((depthPos - E) / rest);
  }

  function familiesFor(shape) {
    if (shape === 'rectangular') return ['R'];
    return ['T', 'V'];
  }

  function comparePairs(burner, opening, shape) {
    var pairs = [];
    if (shape === 'rectangular') {
      pairs.push({ key: 'Width (A)', opening: opening.width, burner: burner.width });
      pairs.push({ key: 'Depth (B)', opening: opening.depth, burner: burner.depth });
      return pairs;
    }
    if (shape === 'tapered') {
      pairs.push({ key: 'Front width (A)', opening: opening.front, burner: burner.front != null ? burner.front : burner.width });
      pairs.push({ key: 'Depth (B)', opening: opening.depth, burner: burner.depth });
      pairs.push({ key: 'Rear width (C)', opening: opening.rear, burner: burner.rear != null ? burner.rear : burner.width });
      return pairs;
    }
    if (shape === 'curved') {
      var front = burner.front != null ? burner.front : burner.width;
      var rear = burner.rear != null ? burner.rear : burner.width;
      pairs.push({ key: 'Front width (A)', opening: opening.front, burner: front });
      pairs.push({ key: 'Depth from chord (C)', opening: opening.depth, burner: burner.depth });
      pairs.push({ key: 'Rear width (D)', opening: opening.rear, burner: rear });
      if (burner.maxWidth != null) {
        pairs.push({ key: 'Maximum width', opening: opening.front, burner: burner.maxWidth });
      }
      return pairs;
    }
    var bFront = burner.front != null ? burner.front : burner.width;
    var bRear = burner.rear != null ? burner.rear : burner.width;
    pairs.push({ key: 'Front width (A)', opening: opening.front, burner: bFront });
    pairs.push({ key: 'Depth (B)', opening: opening.depth, burner: burner.depth });
    pairs.push({ key: 'Rear width (C)', opening: opening.rear, burner: bRear });
    if (burner.maxWidth != null && opening.maxWidth != null) {
      pairs.push({ key: 'Maximum width (D)', opening: opening.maxWidth, burner: burner.maxWidth });
    }
    return pairs;
  }

  function fits(burner, opening, shape) {
    var pairs = comparePairs(burner, opening, shape);
    for (var i = 0; i < pairs.length; i++) {
      if (pairs[i].burner > pairs[i].opening) return false;
    }
    if (shape === 'six' && burner.maxWidth != null && opening.depthToWidest != null && burner.depthToWidest != null) {
      var allowed = openingWidthAt(opening, Math.min(burner.depthToWidest, opening.depth));
      if (burner.maxWidth > allowed) return false;
    }
    return true;
  }

  function scoreCandidate(burner, opening, shape) {
    var pairs = comparePairs(burner, opening, shape);
    var clearances = [];
    var overClose = 0;
    var sum = 0;
    var maxClear = 0;
    for (var i = 0; i < pairs.length; i++) {
      var d = pairs[i].opening - pairs[i].burner;
      clearances.push({ key: pairs[i].key, mm: d, opening: pairs[i].opening, burner: pairs[i].burner });
      sum += d;
      if (d > maxClear) maxClear = d;
      if (d < 1 || d > CLOSE_MM) overClose += 1;
    }
    var exactZero = 0;
    var oversized = false;
    for (var k = 0; k < clearances.length; k++) {
      if (clearances[k].mm === 0) exactZero += 1;
      if (clearances[k].mm < 0) oversized = true;
    }
    var depthClear = 0;
    for (var j = 0; j < clearances.length; j++) {
      if (/depth/i.test(clearances[j].key)) depthClear = Math.max(depthClear, clearances[j].mm);
    }
    return {
      burner: burner,
      clearances: clearances,
      sum: sum,
      maxClear: maxClear,
      overClose: overClose,
      closeMatch: overClose === 0,
      exactSize: !oversized && exactZero > 0,
      rearShelf: depthClear >= SHELF_DEPTH_MM
    };
  }

  function rank(a, b) {
    if (a.closeMatch !== b.closeMatch) return a.closeMatch ? -1 : 1;
    if (a.overClose !== b.overClose) return a.overClose - b.overClose;
    if (a.maxClear !== b.maxClear) return a.maxClear - b.maxClear;
    return a.sum - b.sum;
  }

  function match(input) {
    var shape = input.shape;
    var fuel = input.fuel;
    var height = pickHeight(input.availableHeight);
    if (!height) {
      return { ok: false, reason: 'height', height: null, results: [] };
    }
    var families = familiesFor(shape);
    var pool = BURNERS.filter(function (b) {
      if (families.indexOf(b.family) === -1) return false;
      if (fuel === 'bio' && b.bioEthanol === false) return false;
      return true;
    });
    var fitted = [];
    var exact = [];
    for (var i = 0; i < pool.length; i++) {
      if (!fits(pool[i], input.opening, shape)) continue;
      var scored = scoreCandidate(pool[i], input.opening, shape);
      if (scored.closeMatch) fitted.push(scored);
      else if (scored.exactSize) exact.push(scored);
    }
    fitted.sort(rank);
    exact.sort(rank);
    var results = [];
    if (fitted.length) {
      results.push(fitted[0]);
      if (fitted.length > 1 && fitted[1].closeMatch && fitted[1].burner.id !== fitted[0].burner.id) {
        results.push(fitted[1]);
      }
      return {
        ok: true,
        exact: false,
        reason: null,
        height: height,
        fuel: fuel,
        results: results
      };
    }
    if (exact.length) {
      return {
        ok: true,
        exact: true,
        reason: 'exact',
        height: height,
        fuel: fuel,
        results: [exact[0]]
      };
    }
    return {
      ok: false,
      exact: false,
      reason: 'nofit',
      height: height,
      fuel: fuel,
      results: []
    };
  }

  var api = {
    HEIGHTS: HEIGHTS,
    BURNERS: BURNERS,
    pickHeight: pickHeight,
    match: match,
    fits: fits
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.TSWBurnerMatch = api;

  function num(el) {
    if (!el || el.value === '') return NaN;
    return Number(el.value);
  }

  function showFields(shape) {
    var rootEl = document.getElementById('BurnerMatchCalc');
    if (!rootEl) return;
    var map = {
      rectangular: ['A', 'B'],
      tapered: ['A', 'B', 'C'],
      curved: ['A', 'B', 'C', 'D'],
      six: ['A', 'B', 'C', 'D', 'E']
    };
    var labels = {
      rectangular: { A: 'A — front / width', B: 'B — depth' },
      tapered: { A: 'A — front / width', B: 'B — depth', C: 'C — rear width' },
      curved: { A: 'A', B: 'B', C: 'C', D: 'D' },
      six: { A: 'A (front)', B: 'B', C: 'C', D: 'D', E: 'E' }
    };
    var wanted = map[shape] || [];
    var shapeLabels = labels[shape] || {};
    rootEl.querySelectorAll('[data-burner-dim]').forEach(function (row) {
      var key = row.getAttribute('data-burner-dim');
      var on = wanted.indexOf(key) !== -1;
      row.hidden = !on;
      var input = row.querySelector('input');
      var label = row.querySelector('label');
      if (label && shapeLabels[key]) label.textContent = shapeLabels[key];
      if (input) {
        input.required = on;
        input.disabled = !on;
        if (!on) input.value = '';
      }
    });
    var curvedNote = rootEl.querySelector('[data-burner-curved-note]');
    var sixNote = rootEl.querySelector('[data-burner-six-note]');
    if (curvedNote) curvedNote.hidden = shape !== 'curved';
    if (sixNote) sixNote.hidden = shape !== 'six';
  }

  function openingFromForm(shape, form) {
    var A = num(form.querySelector('[name="burner-a"]'));
    var B = num(form.querySelector('[name="burner-b"]'));
    var C = num(form.querySelector('[name="burner-c"]'));
    var D = num(form.querySelector('[name="burner-d"]'));
    var E = num(form.querySelector('[name="burner-e"]'));
    if (shape === 'rectangular') return { width: A, depth: B };
    if (shape === 'tapered') return { front: A, depth: B, rear: C };
    if (shape === 'curved') return { front: A, curveDepth: B, depth: C, rear: D };
    return { front: A, depth: B, rear: C, maxWidth: D, depthToWidest: E };
  }

  function fuelLabel(fuel) {
    if (fuel === 'lpg') return 'LPG';
    if (fuel === 'bio') return 'Bio Ethanol';
    return 'Natural Gas';
  }

  var NG_PRICES = { coalsManual: 199.99, coalsLogsManual: 219.99, coalsRemote: 499.99, coalsLogsRemote: 519.99 };
  var BIO_PRICES = { coalsManual: 179.99, coalsLogsManual: 199.99, coalsRemote: 429.99, coalsLogsRemote: 459.99 };
  var LPG_SURCHARGE = 8.99;

  function money(n) {
    return '£' + Number(n).toFixed(2);
  }

  function configPriceRows(fuel, height, bioPrices) {
    if (fuel === 'bio') {
      if (bioPrices && bioPrices.length) {
        return bioPrices.map(function (row) {
          return [row.label, Number(String(row.price).replace(/,/g, ''))];
        });
      }
      return [
        ['Coals', BIO_PRICES.coalsManual],
        ['Coals & logs', BIO_PRICES.coalsLogsManual]
      ];
    }
    var extra = fuel === 'lpg' ? LPG_SURCHARGE : 0;
    var rows = [
      ['Coals + manual control', NG_PRICES.coalsManual + extra],
      ['Coals & logs + manual control', NG_PRICES.coalsLogsManual + extra]
    ];
    if (height !== 107) {
      rows.push(['Coals + remote control', NG_PRICES.coalsRemote + extra]);
      rows.push(['Coals & logs + remote control', NG_PRICES.coalsLogsRemote + extra]);
    }
    return rows;
  }

  function engineerReviewHtml(contactUrl, shape, fuel, availableHeight, form) {
    var shapeNames = {
      rectangular: 'Rectangular / square',
      tapered: 'Tapered',
      curved: 'Curved front',
      six: 'Six sided'
    };
    var keys = {
      rectangular: ['A', 'B'],
      tapered: ['A', 'B', 'C'],
      curved: ['A', 'B', 'C', 'D'],
      six: ['A', 'B', 'C', 'D', 'E']
    };
    var vals = {
      A: num(form.querySelector('[name="burner-a"]')),
      B: num(form.querySelector('[name="burner-b"]')),
      C: num(form.querySelector('[name="burner-c"]')),
      D: num(form.querySelector('[name="burner-d"]')),
      E: num(form.querySelector('[name="burner-e"]'))
    };
    var wanted = keys[shape] || [];
    var measureRows = wanted.map(function (k) {
      return '<li><strong>' + k + ':</strong> ' + vals[k] + ' mm</li>';
    }).join('');
    var plain = 'Engineer review — inset gas fire\n\nOpening shape: ' + (shapeNames[shape] || shape) +
      '\n' + wanted.map(function (k) { return k + ': ' + vals[k] + ' mm'; }).join('\n') +
      '\nAvailable burner height: ' + availableHeight + ' mm\nFuel: ' + fuelLabel(fuel);
    var href = contactUrl + (contactUrl.indexOf('?') >= 0 ? '&' : '?') + 'message=' + encodeURIComponent(plain);
    return (
      '<article class="burner-calc__match burner-calc__match--help">' +
      '<h3>Engineer review required</h3>' +
      '<p>Your measurements need to be verified by our engineer. We may be able to modify a burner to suit your fireplace. Please contact The Stove Wizard with your measurements.</p>' +
      '<p>Where appropriate, a welded rear shelf may be available for an additional £15.</p>' +
      '<p>Any alteration or suitability must be confirmed by our engineer before ordering. This does not mean every fireplace can be modified.</p>' +
      '<h4>Your entered details</h4>' +
      '<ul>' +
      '<li><strong>Opening shape:</strong> ' + (shapeNames[shape] || shape) + '</li>' +
      measureRows +
      '<li><strong>Available burner height:</strong> ' + availableHeight + ' mm</li>' +
      '<li><strong>Fuel:</strong> ' + fuelLabel(fuel) + '</li>' +
      '</ul>' +
      '<p>Please include the measurements shown above in your message.</p>' +
      '<p><a class="button button--primary" href="' + href + '">Ask us to check my fireplace</a></p>' +
      '</article>'
    );
  }

  function dimLines(burner) {
    if (burner.shape === 'rectangular') {
      return burner.id + ' — ' + burner.width + 'mm wide × ' + burner.depth + 'mm deep';
    }
    if (burner.shape === 'tapered') {
      return burner.id + ' — front ' + burner.front + 'mm, depth ' + burner.depth + 'mm, rear ' + burner.rear + 'mm';
    }
    return burner.id + ' — front ' + burner.front + 'mm, max ' + burner.maxWidth + 'mm, rear ' + burner.rear + 'mm, depth ' + burner.depth + 'mm';
  }

  function dimOnly(burner) {
    if (burner.shape === 'rectangular') {
      return burner.width + 'mm wide × ' + burner.depth + 'mm deep';
    }
    if (burner.shape === 'tapered') {
      return 'Front ' + burner.front + 'mm, depth ' + burner.depth + 'mm, rear ' + burner.rear + 'mm';
    }
    return 'Front ' + burner.front + 'mm, max ' + burner.maxWidth + 'mm, rear ' + burner.rear + 'mm, depth ' + burner.depth + 'mm';
  }

  function shapeLabel(shape) {
    if (shape === 'rectangular') return 'Rectangular';
    if (shape === 'tapered') return 'Tapered';
    if (shape === 'victorian') return 'Victorian';
    if (shape === 'curved') return 'Curved front';
    if (shape === 'six') return 'Six sided';
    return shape;
  }

  function bind() {
    var rootEl = document.getElementById('BurnerMatchCalc');
    if (!rootEl) return;
    var form = rootEl.querySelector('[data-burner-form]');
    var resultsEl = rootEl.querySelector('[data-burner-results]');
    var productMap = {};
    var mapNode = rootEl.querySelector('[data-burner-products]');
    try {
      productMap = JSON.parse((mapNode && mapNode.textContent) || '{}');
    } catch (e) {
      productMap = {};
    }
    var contactUrl = rootEl.getAttribute('data-contact-url') || '/pages/contact';
    resultsEl.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-add-variant]');
      if (!btn) return;
      ev.preventDefault();
      if (((form.querySelector('[name="burner-fuel"]:checked') || {}).value) === 'bio') return;
      var id = Number(btn.getAttribute('data-add-variant'));
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (res) {
        if (!res.ok) throw new Error('add');
        window.location.href = '/cart';
      }).catch(function () {
        window.location.href = '/cart/' + id + ':1';
      });
    });

    rootEl.querySelectorAll('[name="burner-shape"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        showFields(radio.value);
      });
    });
    var checked = rootEl.querySelector('[name="burner-shape"]:checked');
    showFields(checked ? checked.value : 'rectangular');

    function modelRank(text) {
      var m = String(text).toUpperCase().match(/\b([RTV])\s*([1-9])\b/);
      if (!m) return 900;
      var fam = { R: 0, T: 1, V: 2 };
      return fam[m[1]] * 10 + Number(m[2]);
    }
    var grid = document.querySelector('.product-grid');
    if (grid) {
      var cards = Array.prototype.slice.call(grid.children);
      cards.sort(function (a, b) {
        return modelRank(a.textContent) - modelRank(b.textContent);
      });
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var shape = (form.querySelector('[name="burner-shape"]:checked') || {}).value;
      var fuel = (form.querySelector('[name="burner-fuel"]:checked') || {}).value;
      var availableHeight = num(form.querySelector('[name="burner-height"]'));
      var opening = openingFromForm(shape, form);
      var vals = Object.keys(opening).map(function (k) { return opening[k]; });
      if (!shape || !fuel || !isFinite(availableHeight) || vals.some(function (v) { return !isFinite(v) || v <= 0; })) {
        resultsEl.hidden = false;
        resultsEl.innerHTML = '<div class="notice notice--warning"><p>Please complete every required measurement in millimetres.</p></div>';
        resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var out = match({ shape: shape, fuel: fuel, availableHeight: availableHeight, opening: opening });
      resultsEl.hidden = false;
      if (fuel === 'bio' && out.results && out.results.length) {
        out.results = out.results.filter(function (scored) {
          var inf = productMap[scored.burner.id] || {};
          return inf.bioLive && inf.bioUrl;
        });
        if (!out.results.length) {
          out.ok = false;
          out.exact = false;
        }
      }
      if (!out.height || (!out.ok && !out.exact) || (fuel === 'bio' && !out.results.length)) {
        resultsEl.innerHTML = engineerReviewHtml(contactUrl, shape, fuel, availableHeight, form);
        resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      function card(scored, title, kind) {
        var b = scored.burner;
        var info = productMap[b.id] || {};
        if (typeof info === 'string') {
          info = { url: info };
        }
        var isBio = fuel === 'bio';
        var bioUrl = info.bioLive && info.bioUrl ? info.bioUrl : '';
        var url = isBio
          ? bioUrl
          : (info.live === false ? '' : ((out.height === 107 ? info.manualUrl : info.url) || info.url || ''));
        function findVar(setup) {
          if (isBio) return null;
          var list = info.variants || [];
          for (var vi = 0; vi < list.length; vi++) {
            if (list[vi].fuel === 'bio') continue;
            if (list[vi].fuel === fuel && list[vi].setup === setup) return list[vi];
          }
          return null;
        }
        function addRow(setup, label) {
          if (isBio) return '';
          var v = findVar(setup);
          if (!v) return '';
          return '<p><button type="button" class="button button--primary" data-add-variant="' + v.id + '">Add ' + label + ' — £' + Number(String(v.price).replace(/,/g, '')).toFixed(2) + '</button></p>';
        }
        var control = isBio
          ? '<p><strong>Control:</strong> Coals or coals &amp; logs. Remote control is not available on Bio Ethanol.</p>'
          : (out.height === 107
            ? '<p><strong>Control:</strong> Manual control available. Remote control is not available on the 107mm height.</p>'
            : '<p><strong>Control:</strong> Manual or remote control available.</p>');
        var rows = scored.clearances.map(function (c) {
          return '<tr><th>' + c.key + '</th><td>' + c.opening + 'mm</td><td>' + c.burner + 'mm</td><td>' + c.mm + 'mm</td></tr>';
        }).join('');
        var buy = '';
        if (!isBio) {
          buy = addRow('coalsManual', 'Coals + manual') + addRow('coalsLogsManual', 'Coals & logs + manual');
          if (out.height !== 107) {
            buy += addRow('coalsRemote', 'Coals + remote') + addRow('coalsLogsRemote', 'Coals & logs + remote');
          }
        }
        if (url) buy += '<p><a href="' + url + '">View product</a></p>';
        var photo = '';
        if (info.image) {
          photo = '<div class="burner-calc__photo"><img src="' + info.image + '" alt="' + String(info.alt || b.id).replace(/"/g, '') + '" width="640" height="640"></div>';
        }
        var priceRows = configPriceRows(fuel, out.height, isBio ? info.bioPrices : null).map(function (row) {
          return '<tr><th>' + row[0] + '</th><td>' + money(row[1]) + ' including VAT</td></tr>';
        }).join('');
        var lpgNote = fuel === 'lpg'
          ? '<p>LPG adds £8.99 including VAT to the equivalent Natural Gas configuration. This is a customer charge, not an extra supplier cost.</p>'
          : '';
        var prices = '<h4>Price for this fuel</h4><div class="burner-calc__table-wrap"><table class="burner-calc__table"><tbody>' + priceRows + '</tbody></table></div>' + lpgNote;
        var shelf = scored.rearShelf
          ? '<div class="burner-calc__shelf"><p><strong>Rear shelf may be required</strong></p><p><strong>Rear shelf option — +£15</strong></p><p>Where required, we can weld a metal shelf to the rear of the burner. This is an additional £15. It does not make an oversized burner fit.</p><p><a href="' + contactUrl + '">Request the rear shelf option</a> when you order, or mention it in your checkout note.</p></div>'
          : '';
        var setupText = isBio
          ? 'Coals or coals & logs. Remote control is not available'
          : (out.height === 107
            ? 'Coals or coals & logs, manual control'
            : 'Coals or coals & logs, manual or remote control');
        var leadPrice = configPriceRows(fuel, out.height, isBio ? info.bioPrices : null)[0];
        if (kind === 'alt') {
          var altVar = findVar('coalsManual');
          var altPriceText = altVar ? '£' + Number(String(altVar.price).replace(/,/g, '')).toFixed(2) : money(leadPrice[1]);
          return (
            '<article class="burner-calc__match burner-calc__match--alt">' +
            '<p class="burner-calc__kicker">ALTERNATIVE MATCH</p>' +
            '<p class="burner-calc__model">' + b.id + '</p>' +
            '<p>' + dimOnly(b) + '</p>' +
            '<p><strong>' + altPriceText + '</strong></p>' +
            (url ? '<p><a href="' + url + '">View burner</a></p>' : '') +
            '</article>'
          );
        }
        var facts =
          '<dl class="burner-calc__facts">' +
          '<dt>Burner shape</dt><dd>' + shapeLabel(b.shape) + '</dd>' +
          '<dt>Burner dimensions</dt><dd>' + dimOnly(b) + '</dd>' +
          '<dt>Selected burner height</dt><dd>' + out.height + 'mm</dd>' +
          '<dt>Selected fuel</dt><dd>' + fuelLabel(fuel) + '</dd>' +
          '<dt>Selected setup</dt><dd>' + setupText + '</dd>' +
          '<dt>Price</dt><dd>' + money(leadPrice[1]) + ' including VAT</dd>' +
          '</dl>';
        var table =
          '<h4>Why this matches</h4>' +
          '<div class="burner-calc__table-wrap"><table class="burner-calc__table"><thead><tr><th></th><th>Your opening</th><th>Burner</th><th>Clearance</th></tr></thead><tbody>' +
          rows +
          '</tbody></table></div>';
        if (kind === 'best') {
          var viewBuy = url
            ? '<p><a class="button button--primary burner-calc__cta" href="' + url + '">VIEW &amp; BUY ' + b.id + '</a></p>'
            : '';
          return (
            '<article class="burner-calc__match burner-calc__match--best">' +
            '<p class="burner-calc__kicker">YOUR BEST MATCH</p>' +
            '<p class="burner-calc__model">' + b.id + '</p>' +
            photo +
            facts +
            '<p class="burner-calc__suitable">Suitable for the measurements you entered.</p>' +
            viewBuy +
            buy +
            '<p><a href="' + contactUrl + '">Not sure? Ask us to check your measurements before ordering.</a></p>' +
            '<p class="burner-calc__gassafe">Gas appliances must be installed and commissioned by a suitably qualified Gas Safe registered engineer.</p>' +
            control +
            table +
            prices +
            shelf +
            '</article>'
          );
        }
        return (
          '<article class="burner-calc__match burner-calc__match--exact">' +
          '<h3>' + title + '</h3>' +
          photo +
          '<p class="burner-calc__model">' + b.id + '</p>' +
          facts +
          control +
          table +
          prices +
          shelf +
          buy +
          '</article>'
        );
      }

      var html;
      if (out.exact) {
        html =
          '<div class="notice notice--warning burner-calc__warn burner-calc__warn--exact" role="status">' +
          '<p class="notice__title">EXACT SIZE MATCH — PLEASE RECHECK YOUR FIREPLACE</p>' +
          '<p>We have a burner that matches the measurements you entered exactly. The burner needs a small amount of clearance to fit into the fireplace opening, so please recheck your measurements carefully before ordering.</p>' +
          '<p>If your opening is exactly the same size as the burner, it may not physically fit. If you are unsure, ask us to check your measurements before ordering.</p>' +
          '<p><strong>EXACT SIZE MATCH — CLEARANCE MUST BE CHECKED.</strong> This is not a confirmed standard fit.</p>' +
          '</div>' +
          card(out.results[0], 'EXACT SIZE MATCH — PLEASE RECHECK YOUR FIREPLACE', 'exact') +
          '<p><a class="button button--primary" href="' + contactUrl + '">Ask us to check my fireplace</a></p>';
      } else {
        html =
          '<div class="notice notice--warning burner-calc__warn" role="status">' +
          '<p class="notice__title">Important — please check your measurements</p>' +
          '<p>The burner must be smaller than the fireplace opening so that it can physically fit. Do not order a burner that is the same size as or larger than your measured opening.</p>' +
          '<p>Recommendations are based on the measurements you provide. Please check all measurements carefully before ordering.</p>' +
          '<p>This calculator is a fit-selection aid only. Dimensional matching does not confirm gas or fireplace safety, or that a particular installation is suitable.</p>' +
          '</div>' +
          card(out.results[0], 'YOUR BEST MATCH', 'best');
        if (out.results[1]) {
          html += card(out.results[1], 'ALTERNATIVE MATCH', 'alt');
        }
      }
      resultsEl.innerHTML = html;
      resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
